import { AiFillGithub } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { BsInstagram } from "react-icons/bs";

const Footer = () => {
  return (
    <div className="bg-dark-lighten text-white flex justify-between items-center py-3 px-4 shadow-md mt-3">
      <p className="flex gap-2">
        <span>Made with ❤️ by Shwet Khatri</span>
      </p>
      <div className="flex gap-3 items-center">
        <p className="hidden md:block">Contact me: </p>
        <div className="flex gap-2">
          <a
            href="https://github.com/ShwetKhatri2001"
            target="_blank"
            rel="noreferrer"
            className="text-white hover:scale-110 transition duration-300"
          >
            <AiFillGithub size={30} />
          </a>
          <a
            href="https://www.linkedin.com/in/shwet-khatri-4ab216196/"
            target="_blank"
            rel="noreferrer"
            className="text-[#0072b1] hover:scale-110 transition duration-300"
          >
            <AiFillLinkedin size={30} />
          </a>
          <a
            href="https://www.instagram.com/shwet_khatri_4301/"
            target="_blank"
            rel="noreferrer"
            className="text-[#E1306C] hover:scale-110 transition duration-300"
          >
            <BsInstagram size={30} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
